import * as React from 'react';

import CostAttributionTaskAmount from '../task-amount/CostAttributionTaskAmount';

import type { DeliverableType } from 'types';

import './cost-attribution-task-counter.scss';

export type CCADeliverableDescription = {
  deliverableType: DeliverableType,
  count: number
};

type Props = {
  deliverables: Array<CCADeliverableDescription>
};

const CostAttributionTaskCounter = (
  {
    deliverables
  }: Props
): JSX.Element => (
  <section className="cost-attribution-task-counter">
    {
      deliverables
        .filter(deliverable => deliverable.count > 0)
        .map(deliverable => (
          <CostAttributionTaskAmount
            key={deliverable.deliverableType}
            type={deliverable.deliverableType}
            amount={deliverable.count}
          />
        ))
    }
  </section>
);

export default CostAttributionTaskCounter;
